import { Signal, effect, inject } from '@angular/core';
import { IS_SITE_INTERACT } from '../tokens/is-site-interact';

export const executeAfterSiteInteract = (callback: () => void) => {
  const isInteract: Signal<boolean> = inject(IS_SITE_INTERACT);

  effect(() => {
    if (isInteract()) {
      callback();
    }
  });
};
